import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import Spinner from "./Spinner";

const ButtonWithSpinner = ({ text, loading, forced, icon,type, ...props }) => (
  <Button
    style={{
      position: "relative",
      paddingLeft: 30,
      paddingRight: !!icon ? 20 : 30,
      alignItems: "center",
      display: "flex",
      gap: 5,
      justifyContent: "flex-start",
    }}
    {...props}
    disabled={loading === true || forced === true || props.disabled}
  >
    <Spinner loading={loading} />
    <span style={{ position: "absolute", left: 5, top: 4 }}>
      {!loading ? icon : null}
    </span>{" "}
    {text}
  </Button>
);

ButtonWithSpinner.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.any,
};

export default ButtonWithSpinner;



// WEBPACK FOOTER //
// ./src/components/common/ButtonWithSpinner.jsx